import {
  USER_ID_TODAY_TIME_FAIL,
  USER_ID_TODAY_TIME_REQUEST,
  USER_ID_TODAY_TIME_SUCCESS,
  USER_ID_MONTH_TIME_FAIL,
  USER_ID_MONTH_TIME_REQUEST,
  USER_ID_MONTH_TIME_SUCCESS,
  USER_ID_PREV_TIME_FAIL,
  USER_ID_PREV_TIME_REQUEST,
  USER_ID_PREV_TIME_SUCCESS,
  USER_ID_TODAY_ALL_TIME_FAIL,
  USER_ID_TODAY_ALL_TIME_REQUEST,
  USER_ID_TODAY_ALL_TIME_SUCCESS,
  USER_ID_MONTH_ALL_TIME_FAIL,
  USER_ID_MONTH_ALL_TIME_REQUEST,
  USER_ID_MONTH_ALL_TIME_SUCCESS,
  USER_ID_TODAY_FOR_REPORT_TIME_FAIL,
  USER_ID_TODAY_FOR_REPORT_TIME_REQUEST,
  USER_ID_TODAY_FOR_REPORT_TIME_SUCCESS,
} from "../../types/admin/timerTypes";

export const todayTimerReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_ID_TODAY_TIME_REQUEST:
      return {
        ...state,
        todayTimerLoading: true,
      };
    case USER_ID_TODAY_TIME_SUCCESS:
      return {
        ...state,
        todayTimerLoading: false,
        todayTimerInfo: payload,
        todayTimerError: "",
      };
    case USER_ID_TODAY_TIME_FAIL:
      return {
        ...state,
        todayTimerLoading: false,
        todayTimerInfo: [],
        todayTimerError: payload,
      };
    default:
      return state;
  }
};

export const todayTimerForReportReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_ID_TODAY_FOR_REPORT_TIME_REQUEST:
      return {
        ...state,
        todayReportTimerLoading: true,
      };
    case USER_ID_TODAY_FOR_REPORT_TIME_SUCCESS:
      return {
        ...state,
        todayReportTimerLoading: false,
        todayReportTimerInfo: payload,
        todayReportTimerError: "",
      };
    case USER_ID_TODAY_FOR_REPORT_TIME_FAIL:
      return {
        ...state,
        todayReportTimerLoading: false,
        todayReportTimerInfo: [],
        todayReportTimerError: payload,
      };
    default:
      return state;
  }
};

export const prevTimerReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_ID_PREV_TIME_REQUEST:
      return {
        ...state,
        prevLoading: true,
      };
    case USER_ID_PREV_TIME_SUCCESS:
      return {
        ...state,
        prevLoading: false,
        prevTimerInfo: payload,
        prevError: "",
      };
    case USER_ID_PREV_TIME_FAIL:
      return {
        ...state,
        prevLoading: false,
        prevTimerInfo: [],
        prevError: payload,
      };
    default:
      return state;
  }
};

export const monthTimerReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_ID_MONTH_TIME_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case USER_ID_MONTH_TIME_SUCCESS:
      return {
        ...state,
        loading: false,
        monthTimerInfo: payload,
        error: "",
      };
    case USER_ID_MONTH_TIME_FAIL:
      return {
        ...state,
        loading: false,
        monthTimerInfo: [],
        error: payload,
      };
    default:
      return state;
  }
};

export const todayAllTimerReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_ID_TODAY_ALL_TIME_REQUEST:
      return {
        ...state,
        todayAllTimeLoading: true,
      };
    case USER_ID_TODAY_ALL_TIME_SUCCESS:
      return {
        ...state,
        todayAllTimeLoading: false,
        todayAllTimeInfo: payload,
        todayAllTimeError: "",
      };
    case USER_ID_TODAY_ALL_TIME_FAIL:
      return {
        ...state,
        todayAllTimeLoading: false,
        todayAllTimeInfo: [],
        todayAllTimeError: payload,
      };
    default:
      return state;
  }
};

export const monthAllTimerReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case USER_ID_MONTH_ALL_TIME_REQUEST:
      return {
        ...state,
        monthAllTimeLoading: true,
      };
    case USER_ID_MONTH_ALL_TIME_SUCCESS:
      return {
        ...state,
        monthAllTimeLoading: false,
        monthAllTimeInfo: payload,
        monthAllTimeError: "",
      };
    case USER_ID_MONTH_ALL_TIME_FAIL:
      return {
        ...state,
        monthAllTimeLoading: false,
        monthAllTimeInfo: [],
        monthAllTimeError: payload,
      };
    default:
      return state;
  }
};
